<template>
  <section>
    <!--工具条-->
    <Toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      :selectBut="false"
    >
      <template v-slot:before>
        <el-form-item>
          <el-date-picker
            v-model="startDate"
            type="date"
            placeholder="开始时间"
            value-format="yyyy-MM-dd"
            style="width: 150px"
            :clearable="false"
            :editable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="endDate"
            type="date"
            placeholder="结束时间"
            value-format="yyyy-MM-dd"
            style="width: 150px"
            :clearable="false"
            :editable="false"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template>
        <el-button
          type="success"
          size="small"
          @click="exportAllSalesDetail()"
          :loading="deriveAllLoading"
          >导出全部销售</el-button
        >
        <el-button type="success" size="small" @click="openOrderNumber()"
          >订单量统计</el-button
        >
      </template>
    </Toolbar>
    <div class="datadiv">
      营业额：<span class="text_red">${{ turnover }}</span> 返利总额：<span
        class="text_red"
        >${{ rebate.toFixed(2) }}</span
      >
      余额抵扣总额：<span class="text_red">${{ balance }}</span> 盈利：<span
        class="text_red"
        >${{ profit.toFixed(2) }}</span
      >
    </div>
    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      :height="theight"
      :summary-method="getSummaries"
      show-summary
      row-key="Id"
    >
      <el-table-column type="expand" fixed="left" width="65">
        <template slot="header">
          <el-popover placement="right" trigger="click">
            <el-checkbox-group v-model="colOptions">
              <el-checkbox
                v-for="item in colSelect"
                :label="item"
                :key="item"
              ></el-checkbox>
            </el-checkbox-group>
            <el-button
              slot="reference"
              size="mini"
              icon="el-icon-s-tools"
            ></el-button>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <el-table
            border
            :data="scope.row.ProductTypeList"
            show-summary
            style="width: 600px"
            size="mini"
          >
            <el-table-column :label="$t('Name')">
              <template slot-scope="scope">{{
                field(scope.row.Name)
              }}</template>
            </el-table-column>
            <el-table-column prop="Total" :label="$t('Total')" width="100">
              <template slot-scope="scope">
                <span class="text_red">$ {{ scope.row.Total }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Cover')" width="120">
        <template slot-scope="scope">
          <div
            v-if="scope.row.Cover != null && scope.row.Cover != ''"
            class="coverimg"
            :style="{
              backgroundImage: 'url(' + baseCoverUrl + scope.row.Cover + ')',
            }"
          ></div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Name')" width="200">
        <template slot-scope="scope">{{ field(scope.row.Name) }}</template>
      </el-table-column>
      <el-table-column :label="$t('balance')" width="80">
        <template slot-scope="scope">
          <span class="text_red">s${{ scope.row.Balance }}</span></template
        >
      </el-table-column>
      <el-table-column label="配送" width="100" v-if="colData[0].istrue">
        <template slot-scope="scope">{{
          scope.row.DeliveryModel == 1 ? "商家自送" : "车队配送"
        }}</template>
      </el-table-column>
      <el-table-column
        :label="$t('Shop.LowestPrice')"
        width="100"
        prop="LowestPrice"
        v-if="colData[1].istrue"
      >
        <template slot-scope="scope">
          <span>$ {{ scope.row.LowestPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="佣金比例"
        width="100"
        prop="Commission"
        sortable
        v-if="colData[2].istrue"
      >
        <template slot-scope="scope">
          <span lass="text_red"
            >{{ (scope.row.Commission * 100).toFixed(0) }}%</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="总订单量"
        width="100"
        prop="OrderCount"
        sortable
        v-if="colData[3].istrue"
      ></el-table-column>
      <el-table-column
        label="订单合计"
        width="120"
        prop="OrderReality"
        sortable
        v-if="colData[4].istrue"
      >
        <template slot-scope="scope">
          <span class="text_red">$ {{ scope.row.OrderTotal }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="实际支付"
        width="120"
        prop="OrderTotal"
        sortable
        v-if="colData[5].istrue"
      >
        <template slot-scope="scope">
          <span>$ {{ scope.row.OrderReality }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="余额支付"
        width="120"
        sortable
        prop="OrderDeduct"
        v-if="colData[6].istrue"
      >
        <template slot-scope="scope">
          <span>$ {{ scope.row.OrderDeduct }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="产品合计"
        width="100"
        prop="OrderProduct"
        sortable
        v-if="colData[7].istrue"
      >
        <template slot-scope="scope">
          <span class="text_red">$ {{ scope.row.OrderProduct }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="运费收入"
        width="100"
        prop="FreightTotal"
        sortable
        v-if="colData[8].istrue"
      >
        <template slot-scope="scope">
          <span>$ {{ scope.row.FreightTotal }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="减免合计"
        width="100"
        prop="OrderDerate"
        sortable
        v-if="colData[9].istrue"
      >
        <template slot-scope="scope">
          <span>$ {{ scope.row.OrderDerate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="返利合计"
        width="100"
        prop="OrderDonate"
        sortable
        v-if="colData[10].istrue"
      >
        <template slot-scope="scope">
          <span>$ {{ scope.row.OrderDonate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="盈利合计"
        width="130"
        prop="ProfitTotal"
        sortable
        v-if="colData[11].istrue"
      >
        <template slot-scope="scope">
          <span class="text_red">$ {{ scope.row.ProfitTotal.toFixed(2) }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="Enabled" label="状态" width="70">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Enabled ? "正常" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column :label="$t('operation')" width="210" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="openSalesDetail(scope.row.Id, scope.row.Name['zh_cn'])"
            >销售详细</el-button
          >
          <el-button
            type="success"
            size="small"
            @click="derivedDetail(scope.row.Id)"
            :loading="deriveLoading"
            >导出详细</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total,prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>
    <SalesDetail ref="salesDetailDialog"></SalesDetail>
    <OrderNumberStats ref="orderNumberStatsDialog"></OrderNumberStats>
  </section>
</template>

<script>
import SalesDetail from "./SalesDetail";
import OrderNumberStats from "./OrderNumberStats";
import util from "util/date";
import {
  base,
  getShopStatistics,
  getExportShopOrder,
  getAllOrderExportTeam,
  getAllExportSalesDetail,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";
import moment from "moment";
export default {
  components: {
    SalesDetail,
    OrderNumberStats,
  },
  data() {
    return {
      filters: {
        Name: "",
      },
      startDate: "",
      endDate: "",
      total: 0,
      buttonList: [],
      list: [],
      page: 1,
      listLoading: false,
      theight: 0,
      currentRow: null,
      baseCoverUrl: base + "/FileUpload/ShopCover/b0/",
      deriveLoading: false,
      deriveAllLoading: false,
      turnover: 0,
      balance: 0,
      rebate: 0,
      profit: 0,
      colData: [
        { title: "配送", istrue: true },
        { title: "起送价", istrue: true },
        { title: "佣金比例", istrue: true },
        { title: "总订单量", istrue: true },
        { title: "订单合计", istrue: true },
        { title: "实际支付", istrue: true },
        { title: "余额支付", istrue: true },
        { title: "产品合计", istrue: true },
        { title: "运费收入", istrue: true },
        { title: "减免合计", istrue: true },
        { title: "返利合计", istrue: true },
        { title: "利润合计", istrue: true },
      ],
      colOptions: [
        "配送",
        "起送价",
        "佣金比例",
        "总订单量",
        "订单合计",
        "实际支付",
        "余额支付",
        "产品合计",
        "运费收入",
        "减免合计",
        "返利合计",
        "利润合计",
      ], //默认全选
      colSelect: [
        "配送",
        "起送价",
        "佣金比例",
        "总订单量",
        "订单合计",
        "实际支付",
        "余额支付",
        "产品合计",
        "运费收入",
        "减免合计",
        "返利合计",
        "利润合计",
      ],
    };
  },
  watch: {
    colOptions(valArr) {
      var arr = this.colSelect.filter((i) => valArr.indexOf(i) < 0); // 未选中
      this.colData.filter((i) => {
        if (arr.indexOf(i.title) != -1) {
          i.istrue = false;
          this.$nextTick(() => {
            this.$refs.listTable.doLayout();
          });
        } else {
          i.istrue = true;
          this.$nextTick(() => {
            this.$refs.listTable.doLayout();
          });
        }
      });
    },
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      window.setTimeout(() => {
        if (this.theight === this.getTableHeight(195)) {
          this.theight -= 0.1;
        } else {
          this.theight = this.getTableHeight(195);
        }
      }, 200);
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "合计 " + this.list.length + " bar";
          return;
        }
        if (index >= 7 && index <= 14) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = "$ " + sums[index].toFixed(2);
          } else {
            sums[index] = "";
          }
        }
      });

      return sums;
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        Name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    openSalesDetail(id, name) {
      this.$refs.salesDetailDialog.loadData(
        id,
        name,
        this.startDate,
        this.endDate
      );
    },
    openOrderNumber() {
      this.$refs.orderNumberStatsDialog.loadData(this.startDate, this.endDate);
    },
    derivedDetail(id) {
      this.$confirm("确定生成吗？", this.$t("prompt"), {})
        .then(() => {
          this.deriveLoading = true;
          let para = {
            shopId: id,
            startDate: this.startDate,
            endDate: this.endDate,
          };
          getExportShopOrder(para).then((res) => {
            var filename = res.headers; //下载后文件名
            filename = filename["content-disposition"];
            filename = filename.split(";")[1].split("filename=")[1];
            const link = document.createElement("a");
            const blob = new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURIComponent(filename));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.deriveLoading = false;
          });
        })
        .catch(() => {});
    },
    exportAllTeam() {
      this.$confirm("确定生成吗？", this.$t("prompt"), {})
        .then(() => {
          this.deriveLoading = true;
          let para = {
            status: 4,
            deriveDate: util.formatDate.format(new Date(), "yyyy-MM-dd"),
            startDate: this.startDate,
            endDate: this.endDate,
          };
          getAllOrderExportTeam(para).then((res) => {
            var filename = res.headers; //下载后文件名
            filename = filename["content-disposition"];
            filename = filename.split(";")[1].split("filename=")[1];
            const link = document.createElement("a");
            const blob = new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURIComponent(filename));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.deriveLoading = false;
          });
        })
        .catch(() => {});
    },
    exportAllSalesDetail() {
      this.$confirm("确定生成吗？", this.$t("prompt"), {})
        .then(() => {
          let para = {
            startDate: this.startDate,
            endDate: this.endDate,
          };
          this.deriveAllLoading = true;
          getAllExportSalesDetail(para).then((res) => {
            var filename = res.headers; //下载后文件名
            filename = filename["content-disposition"];
            filename = filename.split(";")[1].split("filename=")[1];
            const link = document.createElement("a");
            const blob = new Blob([res.data], {
              type: "application/zip",
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURIComponent(filename));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.deriveAllLoading = false;
          });
        })
        .catch(() => {});
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    //获取列表
    getList() {
      let para = {
        key: this.filters.Name,
        startTime: this.startDate,
        endTime: this.endDate,
        page: this.page,
      };
      this.listLoading = true;
      getShopStatistics(para).then((res) => {
        this.total = res.data.response.list.dataCount;
        this.list = res.data.response.list.data;
        this.turnover = res.data.response.turnover;
        this.balance = res.data.response.balance;
        this.rebate = res.data.response.rebate;
        this.profit = res.data.response.profit;
        this.listLoading = false;
      });
    },
    datedifference(sDate1, sDate2) {
      //sDate1和sDate2是2006-12-18格式
      var dateSpan, tempDate, iDays;
      sDate1 = Date.parse(sDate1);
      sDate2 = Date.parse(sDate2);
      dateSpan = sDate2 - sDate1;
      dateSpan = Math.abs(dateSpan);
      iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      return iDays + 1;
    },
  },
  mounted() {
    let date = new Date();
    //获取当前月的第一天
    let monthStart = date.setDate(1);
    this.startDate = moment(monthStart).format("YYYY-MM-DD");
    let currentMonth = date.getMonth();
    //获取到下一个月，++currentMonth表示本月+1，一元运算
    let nextMonth = ++currentMonth;
    //获取到下个月的第一天
    let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    //一天时间的毫秒数
    let oneDay = 1000 * 60 * 60 * 24;
    this.endDate = moment(nextMonthFirstDay - oneDay).format("YYYY-MM-DD");

    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style>
.datadiv {
  line-height: 30px;
  font-size: 14px;
}
.datadiv span {
  margin-right: 10px;
}
</style>